// @react/hooks/usePaymentPaymentRoute.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { paymentPaymentRouteStore } from '@core/stores';

/**
 * React hook for PaymentRoute operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { usePaymentPaymentRoute } from '@react/hooks';
 *
 * const PaymentRouteList = observer(() => {
 *   const store = usePaymentPaymentRoute();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function usePaymentPaymentRoute() {
  return paymentPaymentRouteStore;
}
